import React, { useCallback, useState } from 'react';
import { TextField } from '@mui/material';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import BeaconFilterRange from '../../../models/BeaconFilterRange';
import BeaconFilterVariant from '../../../models/BeaconFilterVariant';
import stateFilterRange from '../../../state/stateFilterRange';
import stateFilterVariant from '../../../state/stateFilterVariant';
import stateFilterGene from '../../../state/stateFilterGene';


const patternRange = new RegExp('^([A-Za-z0-9_.]+):([0-9]+)-([0-9]+)$');
const patternVariant = new RegExp('^([A-Za-z0-9_.]+):([0-9]+):([ACGT]*):([ACGT]*)$');

const helperText = "GRCh37. Chromosomal locations are 0-based interbase coordinates. E.g.: 1:1879374:C:T, 1:1879000-1880000";


function QueryVariant() {
    const [text, setText] = useState("");
    const [error, setError] = useState(false);
    const setFilterRange = useSetRecoilState(stateFilterRange);
    const setFilterVariant = useSetRecoilState(stateFilterVariant);
    const filterGene = useRecoilValue(stateFilterGene);

    const disabled = !!filterGene;

    const handleChange = useCallback((event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const value = (event.target.value || "").trim();
        if (0 < value.length) {
            const m = value.match(patternRange);
            if (!!m) {
                const sequence = m[1];
                const start = m[2];
                const end = m[3];
                const range: BeaconFilterRange = { sequence, start, end };
                setFilterVariant(null);
                setFilterRange(range);
                setError(false);
            } else {
                const m = value.match(patternVariant);
                if (!!m) {
                    const sequence = m[1];
                    const position = m[2];
                    const reference = m[3];
                    const alternate = m[4];
                    const variant : BeaconFilterVariant = { sequence, position, reference, alternate };
                    setFilterRange(null);
                    setFilterVariant(variant);
                    setError(false);
                } else {
                    setFilterRange(null);
                    setFilterVariant(null);
                    setError(true);
                }
            }
        } else {
            setFilterRange(null);
            setFilterVariant(null);
            setError(false);
        }
    }, [setText]);
    return (
        <TextField fullWidth variant="outlined" disabled={disabled} helperText={helperText} onChange={handleChange} error={error} />
    );
}


export default QueryVariant;
